module.exports = __webpack_public_path__ + "static/media/sleepyDragonzFrame7.7474d14f.png";